/**
 * Trekvara Meta Pixel — storefront events
 * Requires fbq (base pixel in theme.liquid).
 * content_ids match Shopify → Meta catalog formats:
 *   - shopify_US_{productId}_{variantId} (Facebook & Instagram channel)
 *   - bare variant ID / product ID (group ID in Commerce Manager)
 */
(function () {
  var PIXEL_READY_MS = 8000;

  function whenFbq(cb) {
    if (typeof window.fbq === 'function') {
      cb();
      return;
    }
    var start = Date.now();
    var t = setInterval(function () {
      if (typeof window.fbq === 'function') {
        clearInterval(t);
        cb();
      } else if (Date.now() - start > PIXEL_READY_MS) {
        clearInterval(t);
      }
    }, 50);
  }

  function moneyFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return 0;
    return Math.round(n) / 100;
  }

  function numericId(value) {
    if (value == null || value === '') return '';
    var s = String(value);
    var m = s.match(/(\d{8,})$/);
    return m ? m[1] : s;
  }

  /** IDs Meta Commerce / Shopify channel may use */
  function catalogIds(productId, variantId, sku) {
    var pid = numericId(productId);
    var vid = numericId(variantId);
    var ids = [];
    if (vid) ids.push(vid);
    if (pid) ids.push(pid);
    if (pid && vid) {
      ids.push('shopify_US_' + pid + '_' + vid);
      ids.push('shopify_GB_' + pid + '_' + vid);
    }
    if (sku) ids.push(String(sku));
    return ids.filter(function (id, i, arr) {
      return id && arr.indexOf(id) === i;
    });
  }

  function primaryItemId(productId, variantId, sku) {
    var ids = catalogIds(productId, variantId, sku);
    // Prefer Shopify channel format when we have both IDs
    var prefixed = ids.filter(function (id) {
      return id.indexOf('shopify_US_') === 0;
    })[0];
    return prefixed || ids[0] || '';
  }

  function track(eventName, params) {
    whenFbq(function () {
      try {
        window.fbq('track', eventName, params || {});
      } catch (e) {}
    });
  }

  function trackViewContent() {
    var p = window.trekvaraMeta && window.trekvaraMeta.product;
    if (!p || !(p.variant_id || p.id)) return;
    var ids = catalogIds(p.id, p.variant_id, p.sku);
    track('ViewContent', {
      content_ids: ids,
      content_type: 'product',
      content_name: p.title || undefined,
      content_category: p.type || undefined,
      value: moneyFromCents(p.price),
      currency: (window.trekvaraMeta && window.trekvaraMeta.currency) || 'USD',
      contents: [
        {
          id: primaryItemId(p.id, p.variant_id, p.sku),
          quantity: 1,
          item_price: moneyFromCents(p.price),
        },
      ],
    });
  }

  function trackAddToCartFromLine(item) {
    if (!item) return;
    var productId = item.product_id || item.productId;
    var variantId = item.variant_id || item.id;
    var sku = item.sku;
    var qty = item.quantity || 1;
    var lineValue =
      item.final_line_price != null
        ? moneyFromCents(item.final_line_price)
        : moneyFromCents(item.price) * qty;
    var ids = catalogIds(productId, variantId, sku);
    var primary = primaryItemId(productId, variantId, sku);
    track('AddToCart', {
      content_ids: ids,
      content_type: 'product',
      content_name: item.product_title || item.title || undefined,
      value: lineValue,
      currency: (window.trekvaraMeta && window.trekvaraMeta.currency) || 'USD',
      contents: [
        {
          id: primary,
          quantity: qty,
          item_price: moneyFromCents(item.price),
        },
      ],
    });
  }

  function onCartUpdate(event) {
    if (!event || event.source === 'cart-items') return;
    var data = event.cartData;
    if (!data) return;
    if (data.items && Array.isArray(data.items) && data.item_count != null && !data.product_id && !data.variant_id) {
      return;
    }
    if (data.variant_id || data.id || data.product_id) {
      trackAddToCartFromLine(data);
    }
  }

  function trackInitiateCheckout() {
    var meta = window.trekvaraMeta || {};
    var cart = meta.cart || {};
    var allIds = [];
    var contents = (cart.items || []).map(function (item) {
      var ids = catalogIds(item.product_id, item.variant_id || item.id, item.sku);
      ids.forEach(function (id) {
        if (allIds.indexOf(id) === -1) allIds.push(id);
      });
      return {
        id: primaryItemId(item.product_id, item.variant_id || item.id, item.sku),
        quantity: item.quantity || 1,
        item_price: moneyFromCents(item.price),
      };
    });
    track('InitiateCheckout', {
      content_ids: allIds,
      content_type: 'product',
      value: moneyFromCents(cart.total_price),
      currency: meta.currency || 'USD',
      num_items: cart.item_count || contents.length || 0,
      contents: contents,
    });
  }

  function bindCheckoutClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var a =
          e.target &&
          e.target.closest &&
          e.target.closest('a[href*="/checkout"], button[name="checkout"], [href="/checkout"]');
        if (!a) return;
        trackInitiateCheckout();
      },
      true
    );
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(bindPubSub, 200);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      trackViewContent();
      bindPubSub();
      bindCheckoutClicks();
    });
  } else {
    trackViewContent();
    bindPubSub();
    bindCheckoutClicks();
  }
})();
